<script setup lang="ts">
import { ArrowRight, MailCheck } from 'lucide-vue-next'
import BrandMark from '@/components/BrandMark.vue'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()
</script>

<template>
  <div class="centered-gate">
    <BrandMark />
    <div class="gate-card">
      <span class="gate-icon"><MailCheck :size="28" /></span>
      <span class="eyebrow">Identity check</span>
      <h1>Verify your email</h1>
      <p>
        We sent a secure verification link to <strong>{{ authStore.user?.email }}</strong
        >. Open it, then continue.
      </p>
      <RouterLink class="button button--primary" to="/billing"
        >I’ve verified my email <ArrowRight :size="17"
      /></RouterLink>
      <button class="text-button" type="button" @click="authStore.resendVerification">
        Resend verification email
      </button>
    </div>
  </div>
</template>
